const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Shipper Required To Fill GRN',
  description: 'Shipper Required To Fill GRN',
  sortOrder: 1,
  name: 'is_shipper_required_to_fill_grn',
  documentKey: 'is_shipper_required_to_fill_grn',
  values: {
    is_shipper_required_to_fill_grn: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'is_shipper_required_to_fill_grn',
      documentKey: 'is_shipper_required_to_fill_grn',
    },
  },
};
